module.exports = __webpack_public_path__ + "static/img/lyd.8abf2ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lyd.png
// module id = Dbdj
// module chunks = 0